<style lang="scss" scoped>
  @import '@/assets/styles/variables.scss';

  #logo {
    max-width: 175px;
  }
  .level {
    flex-grow: 1;
    min-width:0; min-height:0;
  }
  .block {
    max-width: 400px;
  }
  .terms {
    background: white;
    width: 45vw;
    height: 45vh;
    padding: 25px;
    font-size: 14px;
    white-space: pre-wrap;
    overflow-y: scroll;
  }
  .error {
    color: $danger;
    padding: 10px;
    border: 1px solid $danger;
    margin-bottom: 20px;
  }
  .rejected {
    padding: 10px 0px 0px 0px;
    color: $danger;
  }
</style>


<template>
  <div class="level">
    <div class="level-item flex-v" v-if="terms">
      <div class="block has-text-centered">
        <!-- logo -->
        <img id="logo" class="image" src="@/assets/images/fend-logo.png">

        <!-- subtitle -->
        <div class="mt-5 mb-5 subtitle is-3 has-text-danger">Terms of Service</div>
      </div>

      <!-- terms -->
      <div class="terms">
        {{terms}}
      </div>

      <!-- warning -->
      <div class="rejected" v-if="rejected">
        You must accept terms of service before proceeding.
      </div>

      <!-- buttons -->
      <p class="mt-5 mb-5">
        Please read our accept of service before proceeding. By choosing "Accept" you agree to Fend's Terms of Service.
      </p>

      <!-- error -->
      <div class="error" v-if="error">
        There was a connection problem when updating your terms of service acceptance.
      </div>

      <div class="buttons">
        <button class="button is-default" @click.prevent="reject">Reject</button>
        <button class="button is-primary mr-5" @click.prevent="accept">Accept</button>
      </div>

    </div>
  </div>
</template>

<script>
import api from '@/api';
import axios from 'axios';

export default {
  name: 'tos',
  data() {
    return {
      error: false,
      rejected: false,
      terms: '',
    };
  },
  methods: {
    reject() {
      this.rejected = true;
    },
    async accept() {
      this.rejected = false;
      try {
        await api.user.update({toc: true});
        this.error = false;
        this.$router.push('/dashboard');
      } catch (error) {
        this.error = error.data || {};
      }
    },
  },
  async mounted() {
    const response = await axios.get(process.env.VUE_APP_TERMS);
    if (response.status === 200) {
      this.terms = response.data;
    } else {
      window.location = '/login';
    }
  }
};
</script>
